/* eslint-disable react/no-array-index-key */
import React from "react"

import { Text, HStack } from "@chakra-ui/react"

import { colors } from "lib/theme"
import { space } from "theme/themeConfig"
import type { TagType } from "types"

type Props = {
  tags?: TagType[]
}

export const Tags: React.FC<Props> = ({ tags = [] }) => (
  <HStack data-testid="productCard-tags" pt={0} mt={0}>
    {tags.length > 0 && (
      <Text
        variant="book1"
        color={colors.contentTertiary}
        mt={`${space["-2"]} !important`}
        textTransform="capitalize"
      >
        {tags &&
          tags
            .filter((a) => a)
            .map(
              (tagItem, index, currentArrayItems) =>
                `${tagItem.name}${
                  index < currentArrayItems.length - 1 ? " / " : ""
                }`
            )}
      </Text>
    )}
  </HStack>
)
